module.exports = __webpack_public_path__ + "static/media/galerija_2022_0021.c0c79e2c.jpg";